import { notifySuccess } from "pages/Errors/Error";
import { CommonResponse } from "types/types";
import * as Yup from "yup";

export const headerHandleChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  setFullName: Function
): void => {
  setFullName(event.target.value);
};

export const headerValidationSchema = Yup.object().shape({
  full_name: Yup.string()
    .matches(/^[A-Za-z]+\s[A-Za-z]+$/, "Invalid name")
    .required("Required"),
});

export const headerSubmitHandler = async (
  fullName: string,
  setFullName: Function,
  email: string,
  UpdateNameRequest: Function,
  setErrors: Function,
  setSubmitting: Function,
  dispatchSetUser: Function,
  user: {
    email: string;
    first_name: string;
    last_name: string;
    token: string;
    id: number;
    customer_id: string | null;
  }
) => {
  const name = fullName.split(" ");
  const data = {
    first_name: name[0],
    last_name: name[1],
  };
  UpdateNameRequest(data, email, setErrors, setSubmitting).then(
    (res: CommonResponse) => {
      if (res) {
        setFullName(fullName);
        setSubmitting(false);
        dispatchSetUser({
          email: user.email,
          token: user.token,
          first_name: data.first_name,
          last_name: data.last_name,
          id: user.id,
          customer_id: user.customer_id,
        });
        notifySuccess(res.message);
      }
    }
  );
};
